





































































import Vue from 'vue';
import { vueVimeoPlayer } from 'vue-vimeo-player';
import { sanityClient, urlFor } from '@/config/sanity';
import VideoPublication from '@/models/videoPublication';
import LoadingIndicator from '@/components/LoadingIndicator.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import SanityBlockContent from '@/components/SanityBlockContent.vue';
import EmployeePortrait from '@/components/EmployeePortrait.vue';
import {
  parseDateTimeFromSanityAutoGeneratedTimestamp,
  formatToLongDisplayFormat,
} from '@/utils/date';
import { calculatePlayerSize } from '@/utils/playerSize';

interface Data {
  isLoading: boolean;
  error: string;
  videoPub: VideoPublication | null;
}

export default Vue.extend({
  name: 'Video',
  components: {
    LoadingIndicator,
    ErrorMessage,
    SanityBlockContent,
    EmployeePortrait,
    vueVimeoPlayer,
  },
  computed: {
    playerSize() {
      const playerSize = calculatePlayerSize(this.$windowWidth);
      return {
        width: playerSize.width,
        height: playerSize.height,
      };
    },
  },
  data(): Data {
    return {
      isLoading: true,
      error: '',
      videoPub: null,
    };
  },
  created() {
    this.fetchVideoPublication();
  },
  methods: {
    urlFor,
    fetchVideoPublication() {
      this.isLoading = true;

      const query = `*[_type == "videoPublication" && slug.current == $slug]{
        "createdAt": _createdAt,
        "updatedAt": _updatedAt,
        "id": _id,
        "key": _key,
        "slug": slug.current,
        title,
        author->{name,image,department,title},
        image,
        status,
        vimeoVideoId,
        customer->{name,description},
        articleHeadline,
        article,
        apparatInvolvement,
        credits,
        relatedVideos,
      }[0]`;

      const params = { slug: this.$route.params.videoPublicationSlug };
      return sanityClient.fetch(query, params).then(
        (result) => {
          const createdAt = parseDateTimeFromSanityAutoGeneratedTimestamp(
            result.createdAt,
          );
          const createdAtFormatted = formatToLongDisplayFormat(createdAt);
          const updatedAt = parseDateTimeFromSanityAutoGeneratedTimestamp(
            result.updatedAt,
          );
          const updatedAtFormatted = formatToLongDisplayFormat(updatedAt);
          const videoPub = {
            ...result,
            createdAt,
            createdAtFormatted,
            updatedAt,
            updatedAtFormatted,
          };

          this.videoPub = videoPub;
          this.isLoading = false;
        },
        (error) => {
          this.error = error;
          this.isLoading = false;
        },
      );
    },
  },
});
